import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { UserService } from '../../../providers/user.service';

@Component({
  selector: 'app-expired',
  templateUrl: './expired.component.html',
  styleUrls: ['./expired.component.scss']
})
export class ExpiredComponent implements OnInit {
  errorMsg;
  constructor(public translator: TranslateService,
    public userService: UserService) {
    this.translator.setDefaultLang('fa');
    this.errorMsg = `کاربر گرامی پتیاک دسترسی سرویس شما به یکی از دلایل اتمام دوره، اتمام حجم و یا عدم اخذ شناسه شاهکار محدود شده است.`;
  }

  ngOnInit() {
    this.userService.getMe().subscribe(
      (user: any) => {
        this.translator.setDefaultLang(user.lang);
        if (new Date(user.expiry_time) < new Date()) {
          if (user.lang === 'fa') {
            this.errorMsg = `کاربر گرامی ${user.name} ${user.family}، اعتبار زمانی سرویس ${user.username} شما در تاریخ ${user.expiry_time_fa} به اتمام رسیده است.`;
          } else {
            this.errorMsg = `Dear ${user.name} ${user.family}, your ${user.username} service is expired from ${user.expiry_time}.`;
          }
        } else if (user.traffic_balance < 0) {
          if (user.lang === 'fa') {
            this.errorMsg = `کاربر گرامی ${user.name} ${user.family}، حجم سرویس ${user.username} شما به اتمام رسیده است.`;
          } else {
            this.errorMsg = `Dear ${user.name} ${user.family}, your ${user.username} service traffic is finished.`;
          }
        } else if (user.has_shahkar_en === 'No') {
          if (user.lang === 'fa') {
            this.errorMsg = `کاربر گرامی ${user.name} ${user.family}، شناسه شاهکار سرویس ${user.username} شما اخذ نشده است با واحد فروش تماس بگیرید.`;
          } else {
            this.errorMsg = `Dear ${user.name} ${user.family}, your ${user.username} service SHAHKAR ID is missing, contact Petiak Sales Department.`;
          }
        } else {
          this.return();
        }
      }, error => {
        notify(error.message || error, 'error', 4000);
      }
    );
  }

  return() {
    window.location.href = 'https://my.petiak.com/';
  }
}
